import { Outlet } from 'react-router-dom'
import { FluentProvider } from '@fluentui/react-components'

const EmptyLayout = () => {
    return (
        <FluentProvider>
            <Outlet />
        </FluentProvider>
    )
}

export default EmptyLayout
